module.exports = __webpack_public_path__ + "static/media/money2.7e2fd5ef.jpg";